<template>
  <SogCard
    :class="_classCard"
  >
    <SogCardContent>
      <table>
        <tr v-show="price?.productTypeId===ProductType.ExportBlank">
          <td>
            <SogDataLabel
              :value="price?.productName"
            />
          </td>
        </tr>
        <tr v-show="price?.productTypeId===ProductType.Addition || price?.productTypeId===ProductType.None">
          <td>
            <SogDataLabel
              :value="price?.productName"
            />
          </td>
        </tr>
        <tr
          v-show="price?.productTypeId!==ProductType.Addition && price?.productTypeId!==ProductType.None && price?.productTypeId!==ProductType.ExportBlank"
        >
          <td>
            <SogDataLabel
              :value="price?.carTypeName"
            />
            &nbsp;
            <SogDataLabel
              v-show="price?.productTypeId===ProductType.Kzk"
              :value="price?.territoryTypeName"
            />
            &nbsp;
            <SogDataLabel
              v-show="price?.productTypeId===ProductType.Zoll||price?.productTypeId===ProductType.Kzk"
              :value="price?.validityDay"
            >
              <span v-show="price?.validityDay!==1">
                Tage
              </span>
              <span v-show="price?.validityDay===1">
                Tag
              </span>
            </SogDataLabel>
          </td>
        </tr>
        <tr>
          <td>
            <SogDataLabel
              :value="price?.manufacturerName"
            />
          </td>
        </tr>
        <tr>
          <td>
            <SogDataLabel
              :value="price?.supplierName"
            />
          </td>
        </tr>
        <tr v-show="price?.productTypeId!==ProductType.ExportBlank">
          <td>
            <SogDataLabel
              :value="price?.grossPrice"
              value-type="Money"
            />
            (
            <SogDataLabel
              :value="price?.shortPrice"
              value-type="Money"
            >
              )
            </SogDataLabel>
          </td>
        </tr>
        <tr
          v-show="price?.productTypeId!==ProductType.ExportBlank && price?.minSaleGrossPrice && price?.grossPrice!==price?.minSaleGrossPrice"
        >
          <td>
            <SogDataLabel
              :value="price?.minSaleGrossPrice"
              value-type="Money"
            />
            (
            <SogDataLabel
              :value="price?.minSaleShortPrice"
              value-type="Money"
            >
              )
            </SogDataLabel>
          </td>
        </tr>
        <tr v-show="price?.productRefId">
          <td>
            Referenznr.
            <SogDataLabel :value="price?.productRefId" />
          </td>
        </tr>
      </table>
    </SogCardContent>
    <slot />
  </SogCard>
</template>

<script setup lang="ts">
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import ProductPrice from "@/shared/model/productPrice";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {ProductType} from "@/shared/model/productType";
import {computed} from "vue";

interface Props {
  price?: ProductPrice
  isSelected?: boolean | string
  allowSelect?: boolean | string
}

const props = withDefaults(defineProps<Props>(), {
    price: undefined, isSelected: undefined, allowSelect: undefined

  }
)


const _classCard = computed(() => {
  let res = "sog-card"
  if (props.isSelected) {
    res += " selected"
  }
  if (props.allowSelect) {
    res += " allow-select"
  }
  return res

})

</script>


<style scoped>
table {
  width: 100%;
}

td {
  text-align: center;
  width: 50%;
}

.sog-card {
  min-width: 250px;
  width: 250px;
  padding-top: 12px;
}

.selected {
  background-color: #4b5563;
  border: 1px solid #22d3ee;
  color: #fff;
}

.allow-select {
  cursor: pointer;
}

/*.e-card-content{font-size:14px;line-height:1.5;padding:0 18px 12px 18px}
*/
.sog-card {
}

</style>
